export default __webpack_public_path__ + "01dae994078e0fed16082172a0034850.png";